import { Button, Card } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-[1180px] items-center px-[30px] py-[26px]">
      <Card className="w-full p-8">
        <h1 className="font-[var(--font-display)] text-[22px] font-semibold tracking-tight text-[var(--ink-0)]">
          Page not found
        </h1>
        <p className="mt-2 text-[15px] text-[var(--ink-2)]">
          This page does not exist or may have been moved.
        </p>
        <div className="mt-6">
          <Button variant="primary" onClick={() => { void navigate('/'); }}>
            Back to dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}
